import { dynamicLoader } from '~/utils';

export const ServiceAreaMultiSelect = dynamicLoader({
  name: 'ServiceAreaMultiSelect',
  importFunc: () => import('./service-area-multi-select'),
});